<template>
  <div class="home">
    <div class="phone-title">智慧应急管理与决策实验室</div>
    <div class="bar" style="margin-top: 20px">
      <div
        class="bar-item"
        :class="{ active: item.value == productType }"
        v-for="item in productTypeOptions"
        :key="item.value"
        @click="handleChangeProductType(item.value)"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="product-list">
      <div
        class="product-group"
        v-for="group in displayPlatformList"
        :key="group.type"
      >
        <div class="group-title">{{ group.label }}</div>
        <el-row :gutter="40">
          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="{ span: 8 }"
            v-for="item in group.productList"
            :key="item.title"
          >
            <div
              class="product-item"
              @click="item.value ? goDetail(item) : goUrl(item.url)"
            >
              <img class="logo" :src="item.logo" />
              <div class="info">
                <div class="name">
                  {{ item.title }}
                </div>
                <div class="description">{{ item.description }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  defineProps,
  defineEmits,
  onMounted,
  inject,
} from "vue";
import { checkUserOperateAuth } from "@/utils/utils.js";
// import DialogPsychologicalSocialWorker from "./DialogPsychologicalSocialWorker.vue";
// import DialogAISocialWorker from "./DialogAISocialWorker.vue";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const emits = defineEmits(["save-scroll", "set-scroll"]);

const openDialogLogin = inject("openDialogLogin");

const productTypeOptions = [
  { label: "全部", value: null },
  { label: "数据资源", value: "resource" },
  { label: "科研平台", value: "research" },
  { label: "教学平台", value: "teaching" },
];
const productType = ref(route.query.type);
const handleChangeProductType = (type) => {
  productType.value = type;
  updatePlatformList();
  updateRoute();
};
const platformList = ref([
  {
    label: "数据资源",
    type: "resource",
    productList: [
      {
        logo: require("@/assets/imgs/resource_5.png"),
        title: "应急企业库",
        description: "应急管理领域相关上市企业数据库",
        url: "https://hpu.smartsowo.com/database/",
      },
      {
        logo: require("@/assets/imgs/resource_3.png"),
        title: "新闻舆情库",
        description: "应急新闻舆情数据库",
        url: "https://www.ringdata.com/news",
      },
      {
        logo: require("@/assets/imgs/resource_4.png"),
        title: "政策文本库",
        description: "应急政策文本数据库",
        url: "https://www.ringdata.com/policy",
      },
      {
        logo: require("@/assets/imgs/EMD.png"),
        title: "应急数据集",
        description: "应急研究报告，统计调查资料，调查数据等数据集",
        url: "https://open.ringdata.com/org/emergency",
      },      
    ],
  },
  {
    label: "科研平台",
    type: "research",
    productList: [
      {
        logo: require("@/assets/imgs/research_1.png"),
        title: "抽样调查",
        description: "调查项目管理、问卷设计、样本抽样、面访调查、网络调查",
        url: "https://dc.ringdata.com/project",
      },
      {
        logo: require("@/assets/imgs/research_2.png"),
        title: "深度访谈",
        description: "访谈项目管理、案主管理、逐字稿整理",
        url: "https://ft.ringdata.com/",
      },
      {
        logo: require("@/assets/imgs/research_3.png"),
        title: "统计分析",
        description: "定量统计分析，支持多人协同",
        url: "https://tj.ringdata.com/",
      },
      {
        logo: require("@/assets/imgs/research_4.png"),
        title: "质性分析",
        description: "基于扎根理论的AI编码分析，支持多人协同",
        url: "https://zx.ringdata.com/",
      },
      {
        logo: require("@/assets/imgs/research_5.png"),
        title: "爬虫采集",
        description: "互联网爬虫采集，支持采集策略",
        url: "https://cj.ringdata.com/",
      },
      {
        logo: require("@/assets/imgs/research_6.png"),
        title: "文本分析",
        description: "大数据文本分析与挖掘",
        url: "https://wx.ringdata.com/",
      },
      {
        logo: require("@/assets/imgs/research_7.png"),
        title: "文献研究",
        description: "AI辅助文献管理、文献对比和文献综述",
        url: "https://review.ringdata.com/",
      },
      {
        logo: require("@/assets/imgs/research_8.png"),
        title: "AI应急知识库问答",
        description: "基于增强检索生成技术的知识问答，接入DeepSeek",
        url: "https://wd.ringdata.com/rag/emai",
      },
      {
        logo: require("@/assets/imgs/research_9.png"),
        title: "AI应急管理策略",
        description: "AI辅助生成应急事件管理策略",
        url: "https://www.smartsowo.com/application/ai-emmergency-strategy/",
      },
    ],
  },
  {
    label: "教学平台",
    type: "teaching",
    productList: [
      {
        logo: require("@/assets/imgs/teaching_7.png"),
        title: "AI数字人",
        description: "AI应急管理数字人，应急咨询和能力测评",
        url: "https://szr.ringdata.com/digital-human/running/7443424673760256",
      },
      {
        logo: require("@/assets/imgs/teaching_1.png"),
        title: "实习管理",
        description: "学生实习管理",
        url: "https://smartsowo.com/application/internship",
      },
      {
        logo: require("@/assets/imgs/teaching_2.png"),
        title: "实践管理",
        description: "实践活动管理",
        url: "https://smartsowo.com/application/practice",
      },
      {
        logo: require("@/assets/imgs/teaching_3.png"),
        title: "案例研讨",
        description: "案例互动讨论",
        url: "https://smartsowo.com/application/interaction",
      },
      {
        logo: require("@/assets/imgs/teaching_4.png"),
        title: "调查仿真",
        description: "抽样调查与统计分析虚拟仿真实验",
        url: "https://smartsowo.com/exp/detail?id=111",
      },
      {
        logo: require("@/assets/imgs/teaching_8.png"),
        title: "访谈仿真",
        description: "深度访谈与质性分析虚拟仿真实验",
        url: "https://smartsowo.com/exp/detail?id=148",
      },
      {
        logo: require("@/assets/imgs/teaching_5.png"),
        title: "大数据仿真",
        description: "舆情采集与文本分析虚拟仿真实验",
        url: "https://smartsowo.com/exp/detail?id=163",
      },
      {
        logo: require("@/assets/imgs/teaching_6.png"),
        title: "在线考试",
        description: "应急管理真题模拟",
        url: "https://smartsowo.com/exam",
      },
      {
        logo: require("@/assets/imgs/teaching_9.png"),
        title: "教学管理",
        description: "课程管理、考试管理、互动管理",
        url: "https://www.smartsowo.com/manage/org/education",
      },
    ],
  },
]);
const displayPlatformList = ref([]);
const updatePlatformList = () => {
  if (productType.value) {
    displayPlatformList.value = platformList.value.filter(
      (item) => item.type == productType.value
    );
  } else {
    displayPlatformList.value = platformList.value;
  }
};
const updateRoute = () => {
  if (productType.value) {
    router.replace({
      name: "Home",
      query: {
        type: productType.value,
      },
    });
  } else {
    router.replace({
      name: "Home",
    });
  }
};

const goUrl = async (url) => {
  await checkUserOperateAuth(openDialogLogin);
  window.open(url, "_blank");
};
const goDetail = (item) => {
  emits("save-scroll");
  router.push({
    name: "Detail",
    params: {
      type: item.value,
    },
    query: {
      type: productType.value,
    },
  });
};

// const dialogPsychologicalSocialWorkerRef = ref(null);
// const dialogAISocialWorkerRef = ref(null);
// const openDialog = async (item) => {
//   await checkUserOperateAuth(openDialogLogin);
//   if (item.title == "心理社工") {
//     dialogPsychologicalSocialWorkerRef.value.openDLG();
//   }
//   if (item.title == "AI社工") {
//     dialogAISocialWorkerRef.value.openDLG();
//   }
// };

onMounted(() => {
  updatePlatformList();
  const savedPosition = sessionStorage.getItem("cgsg_homeScrollTop");
  emits("set-scroll", parseInt(savedPosition, 10));
});
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
  position: relative;
  .phone-title {
    display: none;
  }
  .bar {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 75%;
    gap: 15px;
    .bar-item {
      color: #fff;
      font-size: 15px;
      height: 32px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      cursor: pointer;
      // font-weight: 550;
    }
    .bar-item:hover {
      background-color: rgba(255, 255, 255, 0.34);
    }
    .active {
      background-color: rgba(255, 255, 255, 0.34);
    }
  }
  .product-list {
    width: 75%;
    margin-top: 30px;
    .product-group {
      border-radius: 10px;
      background-color: rgba(255, 255, 255, 0.3);
      padding: 20px;
      margin-bottom: 30px;
      position: relative;
      .group-title {
        color: #fff;
        font-weight: 550;
        margin-bottom: 20px;
        font-size: 15px;
      }
      .product-item {
        display: flex;
        align-items: center;
        padding: 0 20px;
        gap: 15px;
        margin-bottom: 30px;
        height: 110px;
        border-radius: 10px;
        border: 1px solid #efefef;
        background-color: #fff;
        cursor: pointer;
        .logo {
          width: 70px;
          height: 70px;
          border-radius: 16px;
        }
        .info {
          .name {
            font-size: 16px;
            line-height: 23px;
            font-weight: 550;
            margin-bottom: 5px;
          }
          .description {
            color: #848486;
            line-height: 22px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; //行数
            overflow: hidden;
          }
        }
      }
      .product-item:hover {
        box-shadow: 0px 2px 10px -5px rgba(132, 132, 134, 0.4);
        position: relative;
        top: -3px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .home {
    .phone-title {
      font-size: 16px;
      font-weight: 550;
      display: block;
      color: #fff;
      margin-bottom: 20px;
    }
    .bar {
      width: 85%;
      gap: 5px;
      justify-content: flex-start;
      .bar-item {
        font-size: 13px;
        padding: 0 10px;
      }
    }
    .product-list {
      width: 85%;
      margin-top: 15px;
    }
  }
}
</style>
